import React,{useState,useRef,useEffect} from 'react'
import { useParams } from 'react-router-dom'
import axios from 'axios'
import Cleave from 'cleave.js/react'
import { Formik, Field, FieldArray, ErrorMessage, getIn } from 'formik'
import { Form, Input, TextArea, Button, Select, Step, Label,Image, Dropdown, Dimmer, Loader, Icon, Message, Modal, Checkbox, Popup, Table, Segment, TableBody, TableRow, TableCell } from 'semantic-ui-react'

import Spinner from '../../services/spinner'
import AlertMessage from '../../services/alert'
import AlertConfirmation from '../../services/confirmation'

import PopMessage from '../../services/popmessage'



import { WindowReload, WindowURL, WindowLocation, RouteURL, RedirectURL } from '../../services/redirect'
import { ValidateForm, SingleValidateForm } from '../../validations/schemaCustomer'
import { DropdownComponent } from '../../components/options'
import AuthDenied from '../ErrorPage/denied'


export default function EditCustomerComponent(props){

  const params = useParams();

  /*----------------------------------------
    GENERATE PASSWORD
  -----------------------------------------*/

  function MakePassword(length) {
    var result           = '';
    var characters       = 'ABCDEFGHIJKLMNPQRSTUVWXYZabcdefghijklmnpqrstuvwxyz123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
     }
     return result;
  }


  /*----------------------------------------
    SPINNER
  -----------------------------------------*/
  const [spinner,setspinner] = useState(false);
  const [contentspinner, setcontentspinner] = useState({});
  function SpinnerCallback(data){
    if(data.intent=='close'){
      setspinner(false);
    }
  }


  /*------------------------------------------------------
      ALERT CONFIRMATION
      {intent:'delete',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Delete Confirmation!',text:'This process is not ireversible. Once you continue the process, the record will be deleted forever on the database.'}}
    -------------------------------------------------------*/
  const [confirm,setconfirm] = useState(true);
  const [confirmcontent, setconfirmcontent] = useState({});
  function Confirmcallback(data){
    if(data.intent=='close'){
      setconfirm(false);
      if(data.reload){
        WindowReload();
      }
    }
    if(data.intent=='unlink'){
      UnlinkExactGuidConfirm(data.id);
    }
  }


  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
  -------------------------------------------------------*/
  const [notify,setnotify] = useState(true);
  const [nofitycontent, setnofitycontent] = useState({});
  function Notifycallback(data){
    if(data.intent=='close'){
      setnotify(false);
    }
  }

  /*------------------------------------------------------
    ALERT MESSAGE NOTIFY
  -------------------------------------------------------*/
  const [popup,setpopup] = useState(true);
  const [popupMessageContent, setpopupMessageContent] = useState({});
  function PopMessageCallback(data){
    if(data.intent=='close'){
      setpopup(false);
    }
  }





  /*----------------------------------------
    Handle Form Submit
  -----------------------------------------*/
  const [seen,setseen] = useState(false);
  const buttonEl = useRef(null);
  const [buttonclick, setbuttonClick] = useState(0);
  function buttonSubmit(arg){
      setbuttonClick(arg);
      buttonEl.current.click();
  }

  const [stateType, setStateType] = useState(false);
  const [state, setState] = useState({
    id:'',
    exact_guid:'',
    exact_guid_copy:'',
    search_param:'',
    exact_selected:0,

    account_number:'',
    old_account:'',
    account_name:'',
    short_name:'',
    email:'',
    password:'',
    send_password:'2',
    activities:'2',
    comments:'',
    status:'1',
    status_pricing:'2',
    account_type:'1',
    account_type_history:'1',
    address:[{
      id:0,
      pharmacy:'',
      reference:'',
      refcode:'', 
      phone:'',
      line_1:'',
      line_2:'',
      line_3:'',
      city:'',
      county:'',
      postcode:'',
      country:'United Kingdom',
      isDefault:0,
    }],
    history_address:[{
      id:0,
      pharmacy:'',
      reference:'',
      refcode:'', 
      phone:'',
      line_1:'',
      line_2:'',
      line_3:'',
      city:'',
      county:'',
      postcode:'',
      country:'United Kingdom',
      isDefault:0,
    }],
    history_address2:[{
      id:0,
      pharmacy:'',
      reference:'',
      refcode:'', 
      phone:'',
      line_1:'',
      line_2:'',
      line_3:'',
      city:'',
      county:'',
      postcode:'',
      country:'United Kingdom',
      isDefault:0,
    }],
    single_address:{}
  });

  function handleSubmitForm(values, props){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Processing',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','update');
    formData.append('info',JSON.stringify(values));
    axios.post('/admin/customers/request.php',formData)
    .then(function (response) {
      
      let obj = response.data;
      setspinner(false);

      if(obj.message=='success'){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Data successfully saved.'}});
        setnotify(true);
        setTimeout(function() {setnotify(false);},2000);
        if(buttonclick==1){
          setTimeout(function() {
            WindowLocation('/customers/list');
          },2000);
        }else{
          setTimeout(function() {
            WindowReload();
          },2000);
        }
        return false;
      }


      if(obj.message=='error'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
        setnotify(true);
        setTimeout(function() {
          setnotify(false);
        },3000);
        return false;
      }


      if(obj.message=='invalid'){
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Input Error!',text:'Please correct the required fields.'}});
        setnotify(true);
        setTimeout(function() {
          setnotify(false);
        },3000);

        Object.keys(obj.info).forEach(function(key) {
          props.setErrors(obj.info);
        });
        return false;
      }


      if(obj.message=='error_address'){
        setpopupMessageContent({intent:'popup',settings:{data:obj.info.address,centered:false,onclose:true,icon:'error',title:'Reference Error!',text:obj.info.address}});
        setpopup(true);
        return false;
      }


      // Fallback message
      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Something Wrong!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);



    })
    .catch(function (error){
      setspinner(false);
      /*setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);*/
    });


  }

  /*------------------------------------------------------
          Customer Details
  -------------------------------------------------------*/
  function CustomerDetails(id){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','details');
    formData.append('id',id);
    axios.post('/admin/customers/request.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);

      if(obj==0){
        WindowLocation('/customers/list');
        return false;
      }

      setState({
        ...state,
        id:obj.id,
        exact_guid:obj.exact_guid,
        exact_guid_copy:obj.exact_guid,
        account_number:obj.account_number,
        old_account:obj.account_number,
        account_name:obj.account_name,
        short_name:obj.short_name,
        email:obj.email,
        password:obj.password,
        send_password:'2',
        account_type:obj.account_type,
        account_type_history:obj.account_type,
        new_address:obj.id,
        activities:obj.activities,
        comments:obj.comments,
        status:obj.status,
        status_pricing:obj.status_pricing,
        address:obj.address,
        history_address:obj.history_address,
        history_address2:obj.address,
        single_address:obj.single_address
      });

      if(obj.exact_guid!=''){
        ExactLinkDetails(obj.exact_guid);
      }
      
      if(obj.account_type===2){
        setStateType(true);
      }else{
        setStateType(false);
      }


    })
    .catch(function (error){
      /*setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
      },3000);*/
    });
  }


  /*------------------------------------------------------
      SEARCH EXACT
  -------------------------------------------------------*/
  const [searchFound, setSearchFound] = useState(false);
  const [exactSearch, setExactSearch] = useState([]);
  function SearchExactParam(customer_id,search_param){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Searching',text:"Search in progress. Please wait..."}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','search');
    formData.append('search_param',search_param);
    axios.post('/admin/exact/customer.php',formData)
    .then(function (response) {
      let obj = response.data;

      if(obj.error){
        setSearchFound(false);
        setExactSearch([]);
        setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Error Message',text:obj.message}});
        setnotify(true);
        setspinner(false);
        return false;
      }

      if(obj.length==0){
        setspinner(false);
        setSearchFound(true);
        return false;
      }


      setSearchFound(false);
      setExactSearch(obj);

      /*setExactSearch([
        {"ID":"4bdbb4b1-5c23-4c04-ae95-a8a8bd6ab00i","Name":"Target Healthcare Limited"},
        {"ID":"2c51c035-4c04-ae95-a8a8bd6ab00i","Name":"JP Fenton and Son Limited"}
      ]);
      setspinner(false);
      return false;*/

      //console.log(obj);
      setspinner(false);


    })
    .catch(function (error){
      /*setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
        setspinner(false);
      },3000);*/
    });
  }




  function SaveExactLinkAccount(customer_id,exact_guid){

    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Update Exact Guid',text:"Update in progress. Please wait..."}});
    setspinner(true);

    let formData = new FormData();
    formData.append('type','update');
    formData.append('customer_id',customer_id);
    formData.append('guid',exact_guid);
    axios.post('/admin/exact/customer.php',formData)
    .then(function (response) {
      let obj = response.data;

      setspinner(false);

      if(obj=='success'){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:"Exact Guid successfully updated."}});
        setnotify(true);
        setTimeout(function() {
          WindowReload();
          setnotify(false);
        },2000);
        return false;
      }

      if(!obj.error){
        setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Response message!',text:obj.message}});
        setnotify(true);
        setTimeout(function() {
          WindowReload();
          setnotify(false);
        },3000);
        return false;
      }

      setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Error Message!',text:"Exact Guid not successfully updated."}});
      setnotify(true);


    })
    .catch(function (error){
      /*setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {
        setnotify(false);
        setspinner(false);
      },3000);*/
    });
  }


  /*------------------------------------------------------
    UNLINK EXACT
  -------------------------------------------------------*/
  function UnlinkExactGuid(id){
    setconfirmcontent({intent:'unlink',settings:{id:id,centered:false,onclose:true,icon:'warning',title:'Unlink Confirmation!',text:'Are you sure you want to remove the exact linked?'}});
    setconfirm(true);
  }
  
  function UnlinkExactGuidConfirm(id){
    
    setcontentspinner({intent:'spinner',settings:{options:'overlay',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Unlink Exact Guid',text:"Unlink in progress. Please wait..."}});
    setspinner(true);
    setconfirm(false);
  
    let formData = new FormData();
    formData.append('type','unlink');
    formData.append('id',id);
    axios.post('/admin/customers/request.php',formData)
    .then(function (response) {
        let obj = response.data;
  
        setspinner(false);
  
        if(obj=='success'){
          setnofitycontent({intent:'success',settings:{onclose:true,reload:false,title:'Congratulations!',text:'Account successfully unlinked.'}});
          setnotify(true);
          setTimeout(function() {
            WindowReload();
          },2000);
        }else{
          setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Unlink Failed',text:'Exact guid not successfully removed. Please try again.'}});
          setnotify(true);
          setTimeout(function() {setnotify(false);},2000);
        }
  
    })
    .catch(function (error){
      setspinner(false);
      /*setnofitycontent({intent:'error',settings:{onclose:true,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);
      setTimeout(function() {setnotify(false);},3000);*/
    });
  }

  
  /*------------------------------------------------------
    GET DETAILS EXACT
  -------------------------------------------------------*/
  const [exactSpinner, setExactSpinner] = useState(true);
  const [exactData, setExactData] = useState([]);
  function ExactLinkDetails(customer_guid){
    let formData = new FormData();
    formData.append('type','details');
    formData.append('customer_guid',customer_guid);
    axios.post('/admin/exact/customer.php',formData)
    .then(function (response) {
        let obj = response.data;
        if(obj.results.length>0){
          setExactData(obj.results);
        }
        setTimeout(function() {
          setExactSpinner(false);
        },2000);
        
    })
    .catch(function (error){
      setExactSpinner(false);
      setloader(false);
      /*setnofitycontent({intent:'error',settings:{onclose:false,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);*/
    });
 }



  /*------------------------------------------------------
          DROPDOWN OPTIONS
  -------------------------------------------------------*/
  const [countryOptions, setCountryOptions] = useState([]);
  const [activityOptions, setActivityOptions] = useState([]);
  const [statusOptions, setStatusOptions] = useState([]);
  const [yesnoOptions, setyesnoOptions] = useState([]);
  const [onoffOptions, setonoffOptions] = useState([]);
  const [accountTypeOptions, setaccountTypeOptions] = useState([]);
  const HandleOptions = async () => {
    const source = await DropdownComponent();
    setCountryOptions(source.country);
    setActivityOptions(source.activities);
    setStatusOptions(source.status);
    setyesnoOptions(source.yesno);
    setonoffOptions(source.on_off_status);
    setaccountTypeOptions(source.account_type);
  }



  /*---------------------------------------------------------------------------------------------------------------------------------------
         AUTH PERMISSION FOR PAGES
  ----------------------------------------------------------------------------------------------------------------------------------------*/
  const [loader,setloader] = useState(true);
  const [pageId, setPageId] = useState('pe4wsybrqkz1ch2tg');
  const [authPages, setAuthPages] = useState({
    view:0,
    adding:0,
    editing:0,
    deleting:0
  });
  function AuthPagesPermission(){

    setcontentspinner({intent:'spinner',settings:{options:'relative',centered:true,type:'basic',dimmer:'defualt',icon:'spinner',title:'Loading',text:""}});
    setloader(true);

    let formData = new FormData();
    formData.append('type','authPages');
    formData.append('id',pageId);
    axios.post('/admin/users-management/users-permission/request.php',formData)
    .then(function (response) {
        let obj = response.data;
        setAuthPages({
          view:obj.view,
          adding:obj.adding,
          editing:obj.editing,
          deleting:obj.deleting,
        });

        if(obj.view==1&&obj.editing==1){
            if(params.id){
              CustomerDetails(params.id);
            }else{
              WindowLocation('/customers/list');
              return false;
            }
        }
        setloader(false);
        setspinner(false);

    })
    .catch(function (error){
      setloader(false);
      /*setnofitycontent({intent:'error',settings:{onclose:false,reload:false,title:'Server Error!',text:'Failed to connect through the server.'}});
      setnotify(true);*/
    });
 }

  useEffect(()=>{
    AuthPagesPermission();
    HandleOptions();
  },[]);

  return (
    <React.Fragment>

      {confirm&&<AlertConfirmation data={confirmcontent} callback={Confirmcallback}/>}
      {spinner&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {loader&&<Spinner data={contentspinner} callback={SpinnerCallback}/>}
      {notify&&<AlertMessage data={nofitycontent} callback={Notifycallback}/>}
      {popup&&<PopMessage data={popupMessageContent} callback={PopMessageCallback}/>}


      {((authPages['view']==0||authPages['editing']==0)&&!loader)&&<AuthDenied/>}
      {((authPages['view']==1&&authPages['editing']==1)&&!loader)&&<React.Fragment>

      <div className="page-wrapper-one">
        <div className="app-page-title">
         <div className="page-title-wrapper">
            <div><h1>Edit Customer</h1></div>
            <div>
              <Button className='LightGrayButton strong' size='tiny' content='Refresh' icon='sync alternate icon' onClick={()=>WindowReload()}/>
              <Button className='GreenButton strong' size='tiny' content='Back to list' icon='arrow left icon' as="a" href={WindowURL('/customers/list')}/>
            </div>
          </div>
       </div>
      <div className="app-body-wrapper">
      <Form>
          <Formik
            enableReinitialize
            initialValues={state}
            validationSchema={stateType?ValidateForm:SingleValidateForm}
            onSubmit={handleSubmitForm}
            >
            {({ values, isSubmitting, errors, handleChange, handleBlur, handleSubmit, isValid, dirty, touched, setFieldValue, setFieldTouched }) => {
            
            return(
                    <div className="page-form-panel">
                        <div className="page-form-body">
                          
                        <div class="alert-message left error">
                            <div><i class="info circle icon"></i></div>
                            <div><p>Fields with asterisk is required.</p></div>
                        </div>
                        <br/>

                         {/* Layout Form 2 Column*/}
                           <div className="layout-one-column">
                              <div>
                                    <Form.Group widths="equal">
                                        <Field name="account_number">
                                            {({ field, form }) => (
                                            <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                              <label>Account Number</label>
                                              <Cleave {...field} onChange={handleChange} placeholder="Enter number only" options={{numericOnly: true}} maxLength="15"/>
                                              { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                            </Form.Field>
                                            )}
                                      </Field>
                                     </Form.Group>
                                     <Form.Group widths="equal">
                                           <Field name="account_name">
                                               {({ field, form }) => (
                                               <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                 <label>Account Name</label>
                                                 <Input {...field} onChange={handleChange}/>
                                                 { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                               </Form.Field>
                                               )}
                                         </Field>
                                      </Form.Group>
                                      <Form.Group widths="equal">
                                            <Field name="short_name">
                                                {({ field, form }) => (
                                                <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                  <label>Profile Name</label>
                                                  <Input {...field} onChange={handleChange} maxLength="150" placeholder="Max of 20 characters"/>
                                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                </Form.Field>
                                                )}
                                          </Field>
                                       </Form.Group>

                                       <div class="alert-message left info" style={{'margin-bottom':'15px'}}>
                                           <div><i class="info circle icon"></i></div>
                                           <div>
                                              <p>Profile name will be use in customer portal.</p>
                                              <p>Example: Instead of <span style={{'font-weight':'700'}}>John Pharmacy Ltd T/A Charles John Pharmacy</span>, make it short like <span style={{'font-weight':'700'}}>John Pharmacy</span>.</p>
                                           </div>
                                       </div>

                                      <Form.Group widths="equal">
                                          <Field name="email">
                                              {({ field, form }) => (
                                              <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                <label>Email</label>
                                                <Input {...field} onChange={handleChange}/>
                                                { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                              </Form.Field>
                                              )}
                                        </Field>
                                     </Form.Group>

                                    <Form.Group widths="equal">
                                        <Field name="password">
                                            {({ field, form }) => (
                                            <Form.Field required className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                              <label>Password</label>
                                              <Input
                                                type={seen==true?'text':'password'}
                                                icon={<Icon name={seen==true?'eye':'eye slash'} link onClick={()=>setseen(seen==true?false:true)}/>}
                                                fluid {...field}
                                                onChange={handleChange} autoComplete="off"/>
                                              { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                            </Form.Field>
                                            )}
                                      </Field>
                                      <Field name="send_password">
                                          {({ field, form }) => (
                                            <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                              <label>Send password to email?</label>
                                              <Select selectOnBlur={false}
                                                  {...field}
                                                  options={yesnoOptions}
                                                  onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                              { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="fa fa-exclamation-triangle"></i>{form.errors[field.name]}</Label> }
                                            </Form.Field>
                                          )}
                                      </Field>
                                   </Form.Group>


                                   <div class="alert-message left info" style={{'margin-bottom':'5px'}}>
                                       <div><i class="info circle icon"></i></div>
                                       <div><p>You can type the password manually or click the button to generate for you.</p></div>
                                   </div>
                                   <Form.Group inline>
                                     <Button className='BlueButton strong' size='tiny' content='Click to Generate Password'  icon='sync alternate' style={{'margin-right':'20px'}} onClick={()=>{
                                        var password = MakePassword(7);
                                        setFieldValue('password',password);
                                     }}/>
                                   </Form.Group>
                                   <br/>


                                   <br/>


                                   {/*--------------------------------------------------------------------------------
                                      Dynamic address for account type
                                   ---------------------------------------------------------------------------------*/}


                                    
    
                                  <FieldArray
                                    name="address"
                                    render={arrayHelpers => (
                                      <div>

                                          <Form.Group widths="equal">
                                            <Field name="account_type">
                                              {({ field, form }) => (
                                                  <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                    <label>Account Type</label>
                                                    <Select
                                                        selectOnBlur={false}
                                                        search
                                                        {...field}
                                                        options={accountTypeOptions}
                                                        onChange={(e, { value }) => {
                                                          setFieldValue(field.name,value)
                                           
                                                          if(value==1){
                                                            setFieldValue('address',[{
                                                              id:values.single_address.id,
                                                              phone:values.single_address.phone,
                                                              pharmacy:values.single_address.pharmacy,
                                                              refcode:values.single_address.refcode,
                                                              reference:values.single_address.reference,
                                                              line_1:values.single_address.line_1,
                                                              line_2:values.single_address.line_2,
                                                              line_3:values.single_address.line_3,
                                                              city:values.single_address.city,
                                                              county:values.single_address.county,
                                                              postcode:values.single_address.postcode,
                                                              country:values.single_address.country,
                                                            }])
                                                            setStateType(false)
                                                          }

                                                          if(value==2){
                                                            if(values.account_type_history==2){
                                                              setFieldValue('address',values.history_address2);
                                                            }else{
                                                              setFieldValue('address',values.history_address);
                                                            }
                                                            setStateType(true);
                                                          }
                                                          
                                                        }}/>
                                                    { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                  </Form.Field>
                                              )}
                                            </Field>
                                        </Form.Group>

                                        {values.address.map((rowaddress, index) => (
                                          <div key={index}>

                                            <div className="addressLinePanel">

                                            {values.account_type==2&&<Form.Group widths="equal">
                                                <Field name={`address[${index}].pharmacy`}>
                                                        {({ field, form }) => (
                                                        <Form.Field required crequired className={(() => {return getIn(form.errors, `address.${index}.pharmacy`) && getIn(form.touched, `address.${index}.reference`) ? 'error' : "";})()}>

                                                          {values.account_type==2&&<label style={{'position':'relative'}}>Pharmacy
                                                          {(values.address.length>1&&index>0)&&<span style={{'position':'absolute','right':'0', 'cursor':'pointer'}} onClick={() => arrayHelpers.remove(index)}><i className="close icon" style={{'color':'#e41e2e'}}></i></span>}
                                                          </label>}
                                                          {values.account_type==1&&<label>Pharmacy</label>}
                                                          
                                                          {values.address[index].id!=0&&<Input {...field} onChange={handleChange}  maxLength="50" disabled={true}/>}
                                                          {values.address[index].id==0&&<Input {...field} onChange={handleChange}  maxLength="50"/>}

                                                          { getIn(form.touched, `address.${index}.pharmacy`) && getIn(form.errors, `address.${index}.pharmacy`) && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{getIn(form.errors, `address.${index}.reference`)}</Label> }

                                                        </Form.Field>
                                                        )}
                                                </Field>
                                            </Form.Group>}

                                            {values.account_type==2&&<Form.Group widths="equal">
                                                <Field name={`address[${index}].reference`}>
                                                        {({ field, form }) => (
                                                        <Form.Field required crequired className={(() => {return getIn(form.errors, `address.${index}.reference`) && getIn(form.touched, `address.${index}.reference`) ? 'error' : "";})()}>

                                    
                                                          {/*values.account_type==2&&<label style={{'position':'relative'}}>Reference
                                                          {(values.address.length>1&&index>0)&&<span style={{'position':'absolute','right':'0', 'cursor':'pointer'}} onClick={() => arrayHelpers.remove(index)}><i className="close icon" style={{'color':'#e41e2e'}}></i></span>}
                                                          </label>}
                                                        {values.account_type==1&&<label>Reference</label>*/}

                                                          <label>Reference</label>


                                                          {values.address[index].id!=0&&<Input disabled={true} {...field} onChange={handleChange}/>}

                                                          {/*rowaddress.reference==''&&values.address[index].id==0&&<Cleave {...field} onChange={handleChange} placeholder="Enter number only" options={{numericOnly: true}} maxLength="20"/>*/}

                            
                                                          {values.address[index].id==0&&<Cleave {...field} onChange={handleChange} placeholder="Enter number only" options={{numericOnly: true}} maxLength="4" disabled={rowaddress.reference!=''&&values.address[index].id!=0}/>}


                                                          

                                                          { getIn(form.touched, `address.${index}.reference`) && getIn(form.errors, `address.${index}.reference`) && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{getIn(form.errors, `address.${index}.reference`)}</Label> }

                                                        </Form.Field>
                                                        )}
                                                </Field>
                                             </Form.Group>}

                                             <Form.Group widths="equal">
                                                <Field name={`address[${index}].line_1`}>
                                                    {({ field, form }) => (
 
                                                   <Form.Field required className={(() => {return getIn(form.errors, `address.${index}.line_1`) && getIn(form.touched, `address.${index}.line_1`) ? 'error' : "";})()}>

                                                      {values.account_type==1&&<label style={{'position':'relative'}}>Address Line 1
                                                      {(values.address.length>1&&index>0)&&<span style={{'position':'absolute','right':'0', 'cursor':'pointer'}} onClick={() => arrayHelpers.remove(index)}><i className="close icon" style={{'color':'#e41e2e'}}></i></span>}
                                                      </label>}

                                                      {values.account_type==2&&<label>Address Line 1</label>}


                                                      <TextArea rows='2' {...field} onChange={handleChange}/>

                                                      { getIn(form.touched, `address.${index}.line_1`) && getIn(form.errors, `address.${index}.line_1`) && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{getIn(form.errors, `address.${index}.line_1`)}</Label> }

                                                    </Form.Field>
                                                    )}
                                                </Field>
                                              </Form.Group>

                                              <Form.Group widths="equal">
                                                <Field name={`address[${index}].line_2`}>
                                                    {({ field, form }) => (
 
                                                   <Form.Field className={(() => {return getIn(form.errors, `address.${index}.line_2`) && getIn(form.touched, `address.${index}.line_2`) ? 'error' : "";})()}>

                                                      <label>Address Line 2</label>
                                                      <TextArea rows='2' {...field} onChange={handleChange}/>

                                                      { getIn(form.touched, `address.${index}.line_2`) && getIn(form.errors, `address.${index}.line_2`) && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{getIn(form.errors, `address.${index}.line_1`)}</Label> }

                                                    </Form.Field>
                                                    )}
                                                </Field>
                                              </Form.Group>

                                              <Form.Group widths="equal">
                                                <Field name={`address[${index}].line_3`}>
                                                    {({ field, form }) => (
 
                                                   <Form.Field className={(() => {return getIn(form.errors, `address.${index}.line_3`) && getIn(form.touched, `address.${index}.line_3`) ? 'error' : "";})()}>

                                                      <label>Address Line 3</label>
                                                      <TextArea rows='2' {...field} onChange={handleChange}/>

                                                      { getIn(form.touched, `address.${index}.line_3`) && getIn(form.errors, `address.${index}.line_3`) && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{getIn(form.errors, `address.${index}.line_1`)}</Label> }

                                                    </Form.Field>
                                                    )}
                                                </Field>
                                              </Form.Group>

                                              <Form.Group widths="equal">
                                                    <Field name={`address[${index}].phone`}>
                                                        {({ field, form }) => (
                                                        <Form.Field required crequired className={(() => {return getIn(form.errors, `address.${index}.phone`) && getIn(form.touched, `address.${index}.phone`) ? 'error' : "";})()}>

                                                          <label>Phone</label>
                                                          <Input {...field} onChange={handleChange}/>

                                                          { getIn(form.touched, `address.${index}.phone`) && getIn(form.errors, `address.${index}.phone`) && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{getIn(form.errors, `address.${index}.phone`)}</Label> }

                                                        </Form.Field>
                                                        )}
                                                  </Field>
                                                  </Form.Group>
                                                  <Form.Group widths="equal">
                                                      <Field name={`address[${index}].city`}>
                                                          {({ field, form }) => (
                                                          <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                            <label>City</label>
                                                            <Input {...field} onChange={handleChange}/>
                                                            { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                          </Form.Field>
                                                          )}
                                                    </Field>
                                                      <Field name={`address[${index}].county`}>
                                                          {({ field, form }) => (
                                                          <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                            <label>County</label>
                                                            <Input {...field} onChange={handleChange}/>
                                                            { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                          </Form.Field>
                                                          )}
                                                    </Field>
                                                </Form.Group>
                                                <Form.Group widths="equal">
                                                    <Field name={`address[${index}].postcode`}>
                                                        {({ field, form }) => (
                                                        <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                          <label>Postcode</label>
                                                          <Input {...field} onChange={handleChange}/>
                                                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                        </Form.Field>
                                                        )}
                                                  </Field>
                                                  <Field name={`address[${index}].country`}>
                                                    {({ field, form }) => (
                                                        <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                          <label>Country</label>
                                                          <Select
                                                              selectOnBlur={false}
                                                              search
                                                              {...field}
                                                              options={countryOptions}
                                                              onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                        </Form.Field>
                                                    )}
                                                  </Field>
                                              </Form.Group>

                                            </div>

                                          </div>
                                          ))}

                                        {values.account_type==2&&<Button className='GreenButton strong' size='tiny' content='Add Address'  icon='uil-plus icon' onClick={() => {arrayHelpers.push({
                                            id:0,
                                            reference:'',
                                            phone:'',
                                            line_1:'',
                                            line_2:'',
                                            line_3:'',
                                            city:'',
                                            county:'',
                                            postcode:'',
                                            country:'United Kingdom',
                                            isDefault:0,
                                          }
                                        )

                                        setStateType(true)
                                      }

                                       
                                        
                                        }/>}
                                    </div>
                                   )}/>


                                  {/*--------------------------------------------------------------------------------
                                      Dynamic address for account type : End
                                   ---------------------------------------------------------------------------------*/}

                             </div>
                             <div>

                            

                            {/*--------------------------------------------------------------------------------
                                  Exact Panel 
                            ---------------------------------------------------------------------------------*/}
                             <div className="exact_Panel">
                                    <div className="exact_Panelheader">
                                        <h3>Exact Guid</h3>
                                    </div>
                                    <div className="exact_Panelbody">

                                        {/*<Form.Group widths="equal">
                                            <Field name="exact_guid">
                                                {({ field, form }) => (
                                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                  <label>Exact Guid</label>
                                                  <Input readOnly={values.exact_guid_copy!=''} {...field} onChange={handleChange}/>
                                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                </Form.Field>
                                                )}
                                            </Field>
                                        </Form.Group>*/}

                                        {values.exact_guid_copy==''&&<Form.Group widths="equal">
                                            <Field name="search_param">
                                                {({ field, form }) => (
                                                <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                                  <Input {...field} onChange={handleChange} Placeholder='search'/>
                                                  { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                                </Form.Field>
                                                )}
                                            </Field>
                                        </Form.Group>}

                                        {values.exact_guid_copy!=''&&<div class="alert-message left info" style={{'margin-bottom':'15px'}}>
                                           <div><i class="info circle icon"></i></div>
                                           <div>
                                              <p>Customer is already linked to Exact. No action is needed.</p>
                                           </div>
                                       </div>}
                                        
                                        
                                       {values.exact_guid_copy!=''&&<Table definition>
                                       {exactSpinner&&<TableBody><TableRow><TableCell>
                                          <Loader active inline='centered' />
                                        </TableCell></TableRow></TableBody>}
                                       {!exactSpinner&&<React.Fragment>
                                       {exactData.map(function(data, key){
                                          return<TableBody key={key}>
                                                    <TableRow>
                                                      <TableCell style={{'width':'150px'}}>ID</TableCell>
                                                      <TableCell>{data.ID}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell>Code</TableCell>
                                                      <TableCell>{data.Code}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell>Name</TableCell>
                                                      <TableCell>{data.Name}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell>Address Line 1</TableCell>
                                                      <TableCell>{data.AddressLine1}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell>Address Line 2</TableCell>
                                                      <TableCell>{data.AddressLine2}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell>Address Line 3</TableCell>
                                                      <TableCell>{data.AddressLine3}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell>City</TableCell>
                                                      <TableCell>{data.City}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell>Country Name</TableCell>
                                                      <TableCell>{data.CountryName}</TableCell>
                                                    </TableRow>
                                                    <TableRow>
                                                      <TableCell>Postcode</TableCell>
                                                      <TableCell>{data.Postcode}</TableCell>
                                                    </TableRow>
                                              </TableBody>})}
                                            </React.Fragment>}
                                      </Table>}

                                      {searchFound&&<div class="alert-message left warning" style={{'margin-bottom':'15px'}}>
                                           <div><i class="info circle icon"></i></div>
                                           <div>
                                              <h3 style={{'font-weight':'700'}}>Search result</h3>
                                              <p>(0) result found. Try your search again.</p>
                                           </div>
                                       </div>}


                                      {(exactSearch.length>0&&!searchFound)&&<Table celled compact='very'>
                                        <Table.Header>
                                          <Table.Row verticalAlign='middle'>
                                            <Table.HeaderCell colSpan='2' collapsing style={{'font-weight':'700','background-color':'#fffaf3','color':'#573a08'}}>({exactSearch.length}) result{exactSearch.length>1?"'s":''} found</Table.HeaderCell>
                                          </Table.Row>
                                        </Table.Header>
                                        <Table.Body>
                                        {exactSearch.map(function(data, key){
                                            return <Table.Row verticalAlign='middle' positive={data.ID==values.exact_selected&&values.exact_selected!=0} onClick={()=>{
                                                    setFieldValue('exact_selected',data.ID);
                                                    setFieldValue('exact_guid',data.ID);
                                                }}>
                                                <Table.Cell style={{'cursor':'pointer','width':'1%'}} collapsing>
                                                  {data.ID==values.exact_selected&&values.exact_selected!=0&&<i className='uil-check icon' style={{'color':'#21ba45'}}></i>}
                                                  {/*data.ID!=values.exact_selected&&<i className='uil-check icon'></i>*/}
                                                </Table.Cell>
                                                <Table.Cell style={{'cursor':'pointer'}} collapsing>
                                                  <div style={{'font-weight':'800','color':'#344050'}}>{data.Name}</div>
                                                  <div>{data.AddressLine1}</div>
                                                  {data.AddressLine2!=''&&<div>{data.AddressLine2}</div>}
                                                  {data.AddressLine3!=''&&<div>{data.AddressLine3}</div>}
                                                  <div style={{'opacity':'0.8'}}>{data.ID}</div>
                                                </Table.Cell>
                                              </Table.Row>
                                            })}
                                          </Table.Body>
                                        </Table>}

                                            {values.exact_guid_copy==''&&<Form.Group inline>
                                            <Button disabled={values.search_param==''} className='LightGrayButton strong' size='tiny' content='Search'  icon='search icon' style={{'margin-right':'20px'}} onClick={()=>{
                                                SearchExactParam(values.id,values.search_param)
                                            }}/>
                                            <Button disabled={values.exact_guid==''} className='BlueButton strong' size='tiny' content='Update'  icon='save icon' style={{'margin-right':'20px'}} onClick={()=>{
                                                SaveExactLinkAccount(values.id,values.exact_guid)
                                            }}/>
                                        </Form.Group>}

                                      </div>

                                      {values.exact_guid_copy!=''&&<div className="exact_Panelfooter">
                                            <div className="exact_Panelfooterflex">
                                               <div><Button disabled={exactSpinner} className='RedButton' size='mini' content='Unlink Exact' icon='unlink icon' onClick={()=>UnlinkExactGuid(values.id)} /></div>
                                               <div><Button disabled={exactSpinner} className='YellowButton' size='mini' content='Exact Link' icon='arrow right icon' labelPosition='right' as="a" target='_blank' rel='noreferrer' href={'https://start.exactonline.co.uk/docs/CRMAccountCard.aspx?AccountID={'+values.exact_guid+'}&_Division_=20010'}/></div>
                                            </div>
                                      </div>}

                                    </div>
                            {/*--------------------------------------------------------------------------------
                                  Exact Panel End
                            ---------------------------------------------------------------------------------*/}


                              <Form.Group widths="equal">
                                  <Field name="activities">
                                    {({ field, form }) => (
                                        <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                          <label>Activities</label>
                                          <Select
                                              selectOnBlur={false}
                                              search
                                              {...field}
                                              options={activityOptions}
                                              onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                        </Form.Field>
                                    )}
                                  </Field>
                               </Form.Group>
                                <Form.Group widths="equal">
                                  <Field name="comments">
                                      {({ field, form }) => (
                                      <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                        <label>Comments</label>
                                        <TextArea {...field} onChange={handleChange}/>
                                        { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="uil-multiply"></i>{form.errors[field.name]}</Label> }
                                      </Form.Field>
                                      )}
                                  </Field>
                                </Form.Group>
                                <Form.Group widths="equal">
                                  <Field name="status_pricing">
                                      {({ field, form }) => (
                                        <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                          <label>Product pricing?</label>
                                          <Select selectOnBlur={false}
                                              {...field}
                                              options={onoffOptions}
                                              onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="fa fa-exclamation-triangle"></i>{form.errors[field.name]}</Label> }
                                        </Form.Field>
                                      )}
                                  </Field>
                                  <Field name="status">
                                      {({ field, form }) => (
                                        <Form.Field className={(() => {return form.touched[field.name] && form.errors[field.name] ? 'error' : "";})()}>
                                          <label>Status</label>
                                          <Select selectOnBlur={false}
                                              {...field}
                                              options={statusOptions}
                                              onChange={(e, { value }) => setFieldValue(field.name,value)}/>
                                          { form.touched[field.name] && form.errors[field.name] && <Label className="ui above prompt label errorlabel"><i className="fa fa-exclamation-triangle"></i>{form.errors[field.name]}</Label> }
                                        </Form.Field>
                                      )}
                                  </Field>
                                </Form.Group>

                              </div>


                          </div>
                            {/* Layout Form 2 Column End disabled={!(isValid&&dirty)}*/}


                        </div>{/*.page-form-body*/}

                        <div className="page-form-footer">
                            <Button type="button" disabled={spinner} className='LightGrayButton strong' size='small' content='Save and back to list' icon='save icon' onClick={() => buttonSubmit(1)}/>
                            <Button type="button" disabled={spinner} className='PrimaryButton strong' size='small' content='Save and stay on page' icon='save icon' onClick={() => buttonSubmit(2)}/>
                            <button type="button" className="display_none" ref={buttonEl} onClick={handleSubmit}></button>
                        </div>

                 </div>

                )}}
              </Formik>


          </Form>
          </div>
        </div>
      </React.Fragment>}
    </React.Fragment>
  )
}
